module.exports = __webpack_public_path__ + "img/act-of-emotion-4.384bc4e7.jpg";